import { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import api from "../lib/api";
import { Logo, Loading } from "../components/shared";
import { Seo, SITE_URL } from "../components/Seo";
import { Button } from "../components/ui/button";
import { ArrowLeft, Sparkles, Users } from "lucide-react";

export default function KnowledgeArticle() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [article, setArticle] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    api.get(`/public/knowledge/${slug}`).then((r) => setArticle(r.data)).catch(() => setNotFound(true));
  }, [slug]);

  return (
    <div className="min-h-screen bg-background">
      {article && (
        <Seo
          title={`${article.title} — MySocietyMitra Knowledge Centre`}
          description={article.meta_description || (article.answer || "").slice(0, 155)}
          path={`/knowledge/${slug}`}
          jsonLd={{
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": [{
              "@type": "Question",
              "name": article.title,
              "acceptedAnswer": { "@type": "Answer", "text": article.answer },
            }],
            "url": `${SITE_URL}/knowledge/${slug}`,
          }}
        />
      )}
      <header className="sticky top-0 z-50 glass border-b border-white/40">
        <div className="max-w-3xl mx-auto px-5 h-16 flex items-center justify-between">
          <Logo />
          <Button onClick={() => navigate("/login")} className="rounded-full">Start Free</Button>
        </div>
      </header>
      <div className="max-w-3xl mx-auto px-5 py-12">
        <Link to="/knowledge" className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-primary mb-6"><ArrowLeft className="w-4 h-4" /> Back to Knowledge Centre</Link>
        {notFound ? <p className="text-muted-foreground">Article not found.</p> : !article ? <Loading /> : (
          <article>
            <h1 className="font-display text-3xl md:text-4xl font-bold tracking-tight">{article.title}</h1>
            <div className="flex flex-wrap gap-3 mt-4 text-xs text-muted-foreground">
              <span className="bg-muted rounded-full px-3 py-1">Source: {article.source}</span>
              <span className="bg-muted rounded-full px-3 py-1">{article.version}</span>
              <span className="bg-muted rounded-full px-3 py-1">Last reviewed: {article.last_reviewed}</span>
            </div>
            <p className="mt-6 text-lg leading-relaxed text-foreground/90">{article.answer}</p>
            <div className="mt-6 bg-amber-50 border border-amber-200 rounded-xl p-4 text-sm text-amber-800">{article.disclaimer}</div>
            <div className="mt-8 grid sm:grid-cols-2 gap-3">
              <Button onClick={() => navigate("/login")} className="rounded-full gap-2"><Sparkles className="w-4 h-4" /> Ask SocietyMitra</Button>
              <Button variant="outline" onClick={() => navigate("/login")} className="rounded-full gap-2"><Users className="w-4 h-4" /> Request Expert Consultation</Button>
            </div>
          </article>
        )}
      </div>
    </div>
  );
}
